import { useTranslations } from '@vocab/react';

import { getOptionText } from 'src/app/utils/getOptionText';
import { PayType } from 'src/types/salaryTypes';

import translations from './.vocab';

export const usePayTypeTaxonomy = () => {
  const { t } = useTranslations(translations);

  const payTypes = [
    {
      text: t('pay-type-taxonomy-hourly-rate'),
      value: PayType.HOURLY_RATE,
    },
    {
      text: t('pay-type-taxonomy-monthly'),
      value: PayType.MONTHLY,
    },
    {
      text: t('pay-type-taxonomy-annual-salary'),
      value: PayType.ANNUAL_PACKAGE,
    },
    {
      text: t('pay-type-taxonomy-annual-commission'),
      value: PayType.ANNUAL_COMMISSION,
    },
  ];

  const getPayTypeText = (value: string) => getOptionText(payTypes, value);

  return { payTypes, getPayTypeText };
};
